// Soft attack + decay reads clearer than flat tones; triangle is warmer than square
// but still cuts through better than sine alone.

const scheduleNote = (ctx, start, {
  freq, dur, vol, type = 'triangle',
}) => {
  const gain = ctx.createGain();
  gain.connect(ctx.destination);

  const osc = ctx.createOscillator();
  osc.type = type;
  osc.frequency.value = freq;
  osc.connect(gain);

  // Quiet octave harmonic adds brightness without harshness
  const harmonic = ctx.createOscillator();
  const harmonicGain = ctx.createGain();
  harmonic.type = 'sine';
  harmonic.frequency.value = freq * 2;
  harmonic.connect(harmonicGain);
  harmonicGain.connect(gain);
  harmonicGain.gain.value = vol * 0.18;

  const attack = 0.01;
  const release = Math.max(attack + 0.02, dur * 0.88);

  gain.gain.setValueAtTime(0.001, start);
  gain.gain.exponentialRampToValueAtTime(vol, start + attack);
  gain.gain.exponentialRampToValueAtTime(0.001, start + release);

  osc.start(start);
  harmonic.start(start);
  osc.stop(start + dur);
  harmonic.stop(start + dur);
};

const playPattern = (notes) => {
  try {
    const AudioCtx = window.AudioContext || window.webkitAudioContext;
    const ctx = new AudioCtx();
    const now = ctx.currentTime;

    notes.forEach(({
      at, freq, dur = 0.2, vol = 0.4, type,
    }) => {
      scheduleNote(ctx, now + at, {
        freq, dur, vol, type,
      });
    });
  } catch (err) {
    console.warn('Alert sound failed', err);
  }
};

// Three-note rising chime — "someone arrived"
export const playUserJoinBeep = () => playPattern([
  {
    at: 0, freq: 784, dur: 0.18, vol: 0.38,
  },
  {
    at: 0.11, freq: 1000, dur: 0.18, vol: 0.42,
  },
  {
    at: 0.22, freq: 1040, dur: 0.22, vol: 0.46,
  },
]);

// Triple pulse + resolving high note — urgent but not a siren
export const playPeakBeep = () => playPattern([
  {
    at: 0, freq: 587, dur: 0.16, vol: 0.38,
  },
  {
    at: 0.2, freq: 587, dur: 0.16, vol: 0.38,
  },
  {
    at: 0.4, freq: 587, dur: 0.16, vol: 0.38,
  },
  {
    at: 0.64, freq: 880, dur: 0.28, vol: 0.48, type: 'sine',
  },
]);
